var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightarr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 66,
    viewBox: "0 0 101 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.146484 32.8438H76.5825",
    stroke: "black",
    strokeMiterlimit: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9643 32.8445C99.9643 50.4305 85.7073 64.6875 68.1203 64.6875C50.5343 64.6875 36.2773 50.4305 36.2773 32.8445C36.2773 15.2575 50.5343 1.0005 68.1203 1.0005C85.7073 1.0005 99.9643 15.2575 99.9643 32.8445Z",
    stroke: "black",
    strokeMiterlimit: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8949 36.9336L72.2129 36.2016L75.8249 32.8446L72.2129 29.4876L72.8949 28.7546L77.2929 32.8446L72.8949 36.9336Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarr);
export default __webpack_public_path__ + "static/media/rightarr.b56a8b7cecdd21a6a5c3e7310f1006ee.svg";
export { ForwardRef as ReactComponent };